import {
    faPenToSquare,
    faSquareCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../../css/writingcenterbooks.css";
// import SendIcon from "@mui/icons-material/Send";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import Dialog from "@mui/material/Dialog";  
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

import {
  deleteBook,
  editWritingCenter,
  getUser,
  getWritingCenter,
  saveWritingCenter,
  fetchDiaryPdfBlob,
  sendPdfEmail,
} from "../../services/user-service";
import { Del } from "../my-estate/Deletebutton";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
function Writingcenter() {
  const handleRemove = (Id) => {
    deleteBook(Id)
      .then(() => {
        toast.success("Data deleted Successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        fetchData();
        
      })
      .catch(() => {
        toast.error("Error deleting diary:");
      });
  };
  const user = getUser();
  const [imageSrc, setImageSrc] = useState("");
  const base64ToImage = () => {
    const base64String = user.image;
    const trimmedBase64 = base64String ? base64String.trim() : "";
    if (trimmedBase64) {
      setImageSrc(`data:image/jpeg;base64,${trimmedBase64}`);
    }
  };
const downloadPdf = (diaryId) => {
  fetchDiaryPdfBlob(diaryId)
    .then((blobData) => {
      const blob = new Blob([blobData], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `diary_${diaryId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch((error) => {
      toast.error("Failed to download diary PDF");
      console.error("Download error:", error);
    });
};


  // add data
  const handleFormSubmit = (event) => {
    event.preventDefault();
    if (data.bookTitle === "") {
      toast.error("Please add all the fields... ");
      return;
    }
    saveWritingCenter(data)
      .then((resp) => {
        toast.success("Data Added Successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        fetchData();
        resetData();
      })
      .catch((error) => {
        console.log("error : ", error);
      });
  };
  const [data, setData] = useState({
    bookTitle: "",
  });
  const resetData = () => {
    setData({
      bookTitle: "",
    });
  };
  const handleBookChanges = (e, bookdetails) => {
    const value = e.target.value;
    setData((prevState) => ({
      ...prevState,
      [bookdetails]: value,
    }));
  };

  // show data
  const [categories, setCategories] = useState([]);

  const fetchData = () => {
    const userId = getUser().id;
     getWritingCenter(userId)
      .then((res) => {
        setCategories(res);
       })
      .catch(() => {
        toast.error(
          "Error while fetching the data for Writing Center:"
          
        );
      });
  };
const [sendEmailOpen, setSendEmailOpen] = useState(false);
const [toEmail, setToEmail] = useState("");
const [selectedDiaryId, setSelectedDiaryId] = useState(null);
const [sending, setSending] = useState(false);
const handleSendEmailClick = (diaryId) => {
  setSelectedDiaryId(diaryId);
  setSendEmailOpen(true);
};

const handleSendEmail = async () => {
  if (!toEmail) {
    toast.error("Please enter recipient email");
    return;
  }

  const user = JSON.parse(localStorage.getItem("user")); // or use context if available
  const userEmail = user?.email;

  if (!userEmail) {
    toast.error("User email not available");
    return;
  }

  try {
    setSending(true);
    await sendPdfEmail(selectedDiaryId, toEmail, userEmail); // pass both
    toast.success("Email sent successfully");
    setSendEmailOpen(false);
    setToEmail("");
  } catch (error) {
    toast.error("Failed to send email");
  } finally {
    setSending(false);
  }
};


  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.slice(0, maxLength) + "...";
    }
    return text;
  };
  const BOOK = "../writing-center/book/";
  const navigate = useNavigate();
  const handleClick = (book, bookId) => {
   navigate(book + bookId);
  };

  // edit functinality
  const [editedBookTitle, setEditedBookTitle] = useState("");
  const [editingBookId, setEditingBookId] = useState(null);

  // Function to open the edit input field
  const handleEditClick = (bookId, bookTitle) => {
    setEditingBookId(bookId);
    setEditedBookTitle(bookTitle);
  };

  // Function to handle the submission of the edited book title
  const handleEditSubmit = (bookId) => {
    const updatedData = {
      id: bookId,
      bookTitle: editedBookTitle,
    };
     editWritingCenter(bookId, updatedData)
      .then(() => {
        toast.success("Book Title Updated Successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        fetchData();
        setEditingBookId(null);
      })
      .catch((error) => {
        console.log("Error updating book title:", error);
      });
  };

  // page opening  animation
  const [show] = useState(true);

  useEffect(() => {
    fetchData();
    base64ToImage();
  }, []);

  return (
    <div className={`your-component ${show ? "fade-in-element" : ""}`}>
      <form
        onSubmit={handleFormSubmit}
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div className="add_book_box">
          <div className="addbook_inputbox">
            <input
              className="add_book_input_box"
              type="text"
              id="entry-title"
              placeholder="Add New Book... ✏️"
              value={data.bookTitle}
              onChange={(e) => handleBookChanges(e, "bookTitle")}
            />
          </div>
          <div className="addbook_btn">
            <button type="submit" className="user_diary_create_new_book_btn">
              <Tooltip title="Click here to add new book to your writing center">
                Create
              </Tooltip>
            </button>
          </div>
        </div>
      </form>

      <div className="user_diary">
        {categories.map((book) => (
          <div className="book_card_page" key={book.id}>
            <div className="book_card">
              <div
                className="book_card_detalis"
                onClick={() => handleClick(BOOK, book.id)}
              >
                <div className="book_card_image">
                  <img src={imageSrc || "/img/avtar.jpg"} alt="avatar_image" />
                </div>
                <div className="book_card_title">
                  {editingBookId === book.id ? (
                    <div className="edit_btn_for_booktitle">
                      <input
                        className="edit_btn_for_booktitle_inputbox"
                        type="text"
                        value={editedBookTitle}
                        onChange={(e) => setEditedBookTitle(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                      />
                      <button
                        className="edit_btn_for_booktitle_btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditSubmit(book.id);
                        }}
                      >
                        {" "}
                        <Tooltip title="click here to save your edit ">
                          <FontAwesomeIcon
                            icon={faSquareCheck}
                            style={{ color: "#15ca12" }}
                          />
                        </Tooltip>
                      </button>
                    </div>
                  ) : (
                    <h1 className="book_card_heading_title">
                      {truncateText(book.bookTitle, 10)}
                    </h1>
                  )}
                </div>
              </div>
              <div className="book_card_action_buttons">
                <div>
               
                  <Del handleRemove={handleRemove} Id={book.id} />
                </div>
                <div>
                    <button
                      className="book_card_action_edit_buttons"
                      onClick={(e) => {
                        e.stopPropagation();
                        downloadPdf(book.diary[0].id);
                      }}
                    >
                      <Tooltip title="Download diary as PDF">
                        <FontAwesomeIcon icon={faDownload} color="grey" />
                      </Tooltip>
                    </button>
                  </div>
                  <div>
                  <button
                    className="book_card_action_edit_buttons"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSendEmailClick(book.diary[0]?.id); 
                    }}
                  >
                   <Tooltip title="Send diary as PDF via Gmail">
                      {/*<img*/}
                      {/*  src="https://ssl.gstatic.com/ui/v1/icons/mail/rfr/gmail.ico"*/}
                      {/*  alt="Gmail"*/}
                      {/*  style={{ width: 20, height: 20 }}*/}
                      {/*/>*/}
                       <MailOutlineIcon
                           sx={{
                               fontSize: 22,
                               color: "#6c757d"
                           }}
                       />
                    </Tooltip>

                  </button>
                </div>

                <div>
                  <button
                    className="book_card_action_edit_buttons"
                    onClick={() => handleEditClick(book.id, book.bookTitle)}
                  >
                    <Tooltip title="click here to edit diary title">
                      <FontAwesomeIcon icon={faPenToSquare} />
                    </Tooltip>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
        <Dialog open={sendEmailOpen} onClose={() => setSendEmailOpen(false)}>
          <DialogTitle>Send Diary as PDF</DialogTitle>
          <DialogContent>
            <TextField
              label="Recipient Email"
              fullWidth
              type="email"
              value={toEmail}
              onChange={(e) => setToEmail(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setSendEmailOpen(false)}>Cancel</Button>
            <Button onClick={handleSendEmail} disabled={sending || !toEmail}>
              {sending ? "Sending..." : "Send"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      {/* </div> */}
    </div>
  );
}
export default Writingcenter;
